import { createConsumer } from "@rails/actioncable";
import { useEffect, useRef } from "react";
import APPLICATION_GLOBAL_CONFIG from "app/config/applicationGlobalConfig";
import { FlussCableEvent } from "modules/fluss/types/fluss";

let consumer: ReturnType<typeof createConsumer> | null = null;

const cableUrl = () => {
    const configuredBase = APPLICATION_GLOBAL_CONFIG.apiBase || window.location.origin;
    const backend = new URL(configuredBase, window.location.origin);
    const protocol = backend.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${backend.host}/api/cable`;
};

const flussConsumer = () => {
    consumer ||= createConsumer(cableUrl());
    return consumer;
};

export const useFlussCable = ({
    instanceId,
    inbox = false,
    monitor = false,
    onReceived,
}: {
    instanceId?: string;
    inbox?: boolean;
    monitor?: boolean;
    onReceived: (event: FlussCableEvent) => void;
}) => {
    const callbackRef = useRef(onReceived);
    callbackRef.current = onReceived;

    useEffect(() => {
        if (!instanceId && !inbox && !monitor) return;

        const subscription = flussConsumer().subscriptions.create(
            {
                channel: "FlussChannel",
                ...(instanceId ? { instance_id: instanceId } : monitor ? { monitor: true } : { inbox: true }),
            },
            {
                received: (event: FlussCableEvent) => callbackRef.current(event),
            }
        );

        return () => {
            subscription.unsubscribe();
        };
    }, [inbox, instanceId, monitor]);
};
